/**
 * GraphQL query for fetching stop schedule data.
 * References:
 * - OTP API Documentation: https://docs.opentripplanner.org/api/dev-2.x/graphql-gtfs/queries/stop
 * - GraphiQL: http://rj-st-mapapp01:52425/graphiql
 */
export const DEPARTURES_FOR_STOP_QUERY = /* graphql */ `
query StopTimes(
  $serviceDayYYYYMMDD: String!
  $stopId: String!
) {
  stop(id: $stopId) {
    stoptimesForServiceDate (date: $serviceDayYYYYMMDD, omitNonPickups: true, omitCanceled: false) {
      stoptimes {
        headsign
        scheduledDeparture
        serviceDay
        trip {
          id
          route {
            gtfsId
            shortName
            longName
            desc
          }
        }
      }           
    }
  }
}
`;
